<dx-load-panel [closeOnOutsideClick]="false" [(visible)]="IsLoading"> </dx-load-panel>
<div class="security-container" fxLayout="row" fxLayoutAlign="center center">
    <div fxLayout="column center"
         (capsLock)="changeCapsOn($event)">
        <div class="dx-card">
            <div fxLayout="row" fxLayoutAlign="center center">
                <img class="logo" [src]="applicationInfo.logo" alt="Laboratory Logo" />
            </div>
            <form (submit)="formSubmitted()" autocomplete="off">
                <h4 class="security-hint">Use your credentials to login</h4>
                <dx-form
                    [(formData)]="formData"
                    [readOnly]="false"
                    [labelLocation]="'top'"
                    [showValidationSummary]="true"
                >
                    <dxi-item dataField="loginId">
                        <dxo-label text="Email"></dxo-label>
                        <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                        <dxi-validation-rule type="email"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="password" [editorOptions]="{ mode: 'password' }">
                        <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item
                        itemType="button"
                        horizontalAlignment="center"
                        [buttonOptions]="{ text: 'Login', useSubmitBehavior: true }"
                    >
                    </dxi-item>
                </dx-form>
                <div class="link-container">
                    <a routerLink="/password-recovery">Can't login?</a>
                </div>
                <div class="link-container">
                    <a routerLink="/patient-sign-up">Patient Sign Up</a>
                </div>
              <div class="link-container">
                <a routerLink="/secret-code-verification">Pay as guest</a>
              </div>
            </form>
        </div>
    </div>
</div>
